/**
 * Template names the demo suggests for the Won handoff, by account industry.
 * Real templates come from Lookups.Templates, so suggestions are matched by name (case-insensitive);
 * a suggestion with no matching template is simply skipped.
 */
export const INDUSTRY_TEMPLATES = {
    Healthcare: ['HIPAA Compliance Rounds', 'Fire Safety Monthly'],
    'Food service': ['Food Safety Daily', 'Store Opening Checklist'],
    Grocery: ['Food Safety Daily', 'Cold Chain Log'],
    Hospitality: ['Housekeeping QA', 'Fire Safety Monthly'],
    Logistics: ['Warehouse Forklift Check', 'Fire Safety Monthly'],
    Retail: ['Store Opening Checklist', 'Fire Safety Monthly'],
    Manufacturing: ['HSE Site Walk', 'Warehouse Forklift Check'],
    Education: ['Fire Safety Monthly'],
}

const norm = text => String(text || '').trim().toLowerCase()

/**
 * @param {string|null|undefined} industry
 * @param {{TemplateId: number, TemplateName: string}[]} templates
 * @returns {number[]} ids of templates to pre-select
 */
export const suggestTemplateIds = (industry, templates) => {
    const wanted = (INDUSTRY_TEMPLATES[industry] || []).map(norm)
    if (!wanted.length) return []
    return (templates || []).filter(t => wanted.includes(norm(t.TemplateName))).map(t => t.TemplateId)
}

/** One site per line -> trimmed, non-empty, de-duplicated list. */
export const parseSites = text =>
    Array.from(
        new Set(
            String(text || '')
                .split(/\r?\n/)
                .map(line => line.trim())
                .filter(Boolean),
        ),
    )
